import React from 'react'

import FileInput from './FileInput'
import { Button, Container, P, Textarea } from '../primitives'

const ErrorForm = ({
	text,
	updateText,
	uploadFile,
	uploadStatus,
	viewResults,
}) => (
	<Container onSubmit={e => e.preventDefault}>
		<P margin={10} center>
			Find your most recent <strong>lastException</strong> file and upload it by 
			clicking the 'Upload lastException File' button or paste the contents of 
			one into the text area.
		</P>
		<P margin={10} center>
			Exception files are located in the Sims 4 Documents 
			folder <strong>(\Documents\Electronic Arts\The Sims 4)</strong>.
		</P>
        <P margin={10} center>
            Only '<strong>lastException</strong>' files are allowed.
        </P>
		<FileInput uploadFile={uploadFile} uploadStatus={uploadStatus} />
		<P margin={10} center>
			or
		</P>
		<Textarea
			value={text}
			onChange={updateText}
			data-gramm_editor="false"
			placeholder="Paste your lastException file contents here."
		/>
		<Button disabled={!text} onClick={viewResults}>
			Find Errors
		</Button>
	</Container>
)

export default ErrorForm



// WEBPACK FOOTER //
// ./src/components/ErrorForm.js